import { useQuery } from 'react-query';
import { Link } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';

import DbApi from 'api/db';
import Header from 'components/ui/Header';

const ImporterHeader = ({ dbId }) => {
  const { t } = useTranslation();
  const { data } = useQuery(['importer-db', dbId], () => DbApi.get(dbId));

  if (!data) {
    return null;
  }

  const schema = data.schema || {};
  const back_link = `/databases/${dbId}/datasets`;

  return (
    <Header>
      <div className="d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center">
          <div className="me-3">
            <Link to={back_link}>
              <FiArrowLeft size={24} />
            </Link>
          </div>

          <div>
            <div>
              <small className="text-uppercase">
                <Link to={back_link}>databases</Link> / {schema.title}
              </small>
            </div>
            <h2 className="m-0 p-0 fw-lighter">{t('importer.title')}</h2>
          </div>
        </div>
      </div>
    </Header>
  );
};

export default ImporterHeader;
